// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"777":"296ea028","787":"6c61533a","996":"7b0adfb1"}[chunkId] + ".chunk.js";
};